import {
  LOG_IN,
  LOG_OUT,
  SET_LOADING,
  SET_USER,
  COMPLETED_DATA,
  INTERRUPT_TENNIS,
  INTERRUPT_X10,
  INTERRUPT_SAISON,
  INTERRUPT_RENOUVELLEMENT_SAISON,
  SET_SOCIAL_NETWORKS,
  INTERRUPT_RENDEZ_VOUS
} from './actions'

const setUser = (userObj, accessToken, ssoConnected=false) => {

  return {
    type: SET_USER,
    payload: { userObj, accessToken, ssoConnected }
  }
}

const logIn = () => {
  return {
    type: LOG_IN
  }
}

const logOut = () => {
  return {
    type: LOG_OUT
  }
}

const setLoading = (loading) => {
  return {
    type: SET_LOADING,
    payload: loading
  }
}

const setDataCompleted = (etat) => {
  return {
    type: COMPLETED_DATA,
    payload: etat
  }
}

const setInterruptTennis = (isInterruptTennis) => {
  return {
    type: INTERRUPT_TENNIS,
    payload: isInterruptTennis
  }
}

const setInterruptX10 = (isInterruptX10) => {
  return {
    type: INTERRUPT_X10,
    payload: isInterruptX10
  }
}

const setInterruptSaison = (isInterruptSaison) => {
  return {
    type: INTERRUPT_SAISON,
    payload: isInterruptSaison
  }
}

const setInterruptRenouvellementSaison = (isInterruptRenouvellementSaison) => {
  return {
    type: INTERRUPT_RENOUVELLEMENT_SAISON,
    payload: isInterruptRenouvellementSaison
  }
}

const setSocialNetworks = (socialNetworks) => {
  return {
    type: SET_SOCIAL_NETWORKS,
    payload: socialNetworks
  }
}

const setInterruptRendezVous = (isInterruptRendezVous) => {
  return {
    type: INTERRUPT_RENDEZ_VOUS,
    payload: isInterruptRendezVous
  }
}

/**
 * Appel Fetch vers l'API
 * @param {*} url : route de la requête
 * @param {*} body : parametres de la requête
 * @param {*} dispatch : service pour gérer les chargements
 * @param {*} token : jwt token pour vérifier l'autorisation d'accéder à la requête
 */
const fetchPostAPI = (url, body, dispatch, token) => {
  return new Promise(async (resolve) => {
    try {
      if(dispatch) dispatch(setLoading(true))
      const res = await fetch(process.env.REACT_APP_API_PATH + url, {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization' : token
        },
        body: JSON.stringify(body)
      })
      const json = await res.json()
            
      resolve({ res: res, json: json })
    } catch (err) {           
      resolve({ err: 'Service non disponible' })
    }
    finally{
      if(dispatch) dispatch(setLoading(false))
    }
  })
}

const fetchGetAPI = (url, dispatch, token) => {
  return new Promise(async (resolve) => {
    try {
      if(dispatch) dispatch(setLoading(true))

      const res = await fetch(process.env.REACT_APP_API_PATH + url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization' : token
        }
      })
      const json = await res.json()
            
      resolve({ res: res, json: json })
    } catch (err) {           
      resolve({ err: 'Service non disponible' })
    }
    finally{
      if(dispatch) dispatch(setLoading(false))
    }
  })
}


const fetchDeleteAPI = (url, body, dispatch, token) => {
  return new Promise(async (resolve) => {
    try {
      if(dispatch) dispatch(setLoading(true))

      const res = await fetch(process.env.REACT_APP_API_PATH + url, {
        method: 'delete',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization' : token
        },
        body: JSON.stringify(body)
      })
      const json = await res.json()
            
      resolve({ res: res, json: json })
    } catch (err) {           
      resolve({ err: 'Service non disponible' })
    }
    finally{
      if(dispatch) dispatch(setLoading(false))
    }
  })
}



const exp = {
  setUser,
  logIn,
  logOut,
  setLoading,
  fetchPostAPI,
  fetchGetAPI,
  fetchDeleteAPI,
  setDataCompleted,
  setInterruptTennis,
  setInterruptX10,
  setInterruptSaison,
  setInterruptRenouvellementSaison,
  setSocialNetworks,
  setInterruptRendezVous
}
export default exp
